
import * as DeputyActions from './deputy.actions';
import * as AdministratorModeActions from './administrator-mode.actions';

export {
    DeputyActions,
    AdministratorModeActions
};
